export default "__VITE_ASSET__CNVVcj5S__"